@if (imageDataUrl()) {
  <img class="image-field-img" [src]="imageDataUrl()" [alt]="control().label || 'Image'">
} @else {
  <div class="image-field-placeholder">
    <mat-icon>image</mat-icon>
    <span>Image populated from entity data</span>
  </div>
}
